import {connect} from 'react-redux'
import {Link} from 'react-router'
import {loginRequest} from 'actions'
import LoginForm from './LoginForm'
import styles from './style.css'
import AuthTitle from 'components/Titles/AuthTitle'

class Login extends React.Component {
  render () {
    let {dispatch} = this.props
    let {currentlySending} = this.props.data.moka
    return (
      <div className={styles.root} id='login-page'>
        <AuthTitle title='Sign In' />
        <LoginForm
          dispatch={dispatch}
          history={this.props.history}
          onSubmit={this.handleSubmit}
          btnText={'Sign In'}
          currentlySending={currentlySending}
        />
        <div className={styles['margin-link']}>
          <Link className={`${styles.left} forgot-password-link`} to='/forgot'>Forgot Your Password?</Link>
          <Link className={styles.right} to='/register'>Sign Up Today</Link>
        </div>
      </div>
    )
  }

  /**
   * Handle submission of login form
   * @param values the JSON containing {email,password}
   */
  handleSubmit = (values) => {
    const {email, password} = values
    let trimEmail = email.trim()
    const nextURL = this.props.location.query.next
    if (nextURL) {
      this.props.dispatch(loginRequest({email: trimEmail, password}, nextURL))
    } else {
      this.props.dispatch(loginRequest({email: trimEmail, password}))
    }
  }
}

Login.propTypes = {
  data: React.PropTypes.object,
  history: React.PropTypes.object,
  dispatch: React.PropTypes.func
}

// Which props do we want to inject, given the global state?
function select (state) {
  return {
    data: state
  }
}

// Wrap the component to inject dispatch and state into it
export default connect(select)(Login)



// WEBPACK FOOTER //
// ./app/pages/Login/Login.js